// USER CONTEXT
export const USER_LOGOUT = 'USER_LOGOUT'
export const USER_UPDATE = 'USER_UPDATE'
export const USER_MODULES = 'USER_MODULES'

export const USER_UPD_SESS_STORE = 'USER_UPD_SESS_STORE' 
export const USER_CLEARALL = 'USER_CLEARALL' 

